import React from "react";
import { Navigate } from "react-router-dom";
import { getUser, isAuthenticated } from "../utils/auth";
import { memoryStorage } from "../utils/memoryStorage";

const ProtectedRoute = ({ children, allowedRoles }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  const user = getUser();
  const role = (user?.role || "").toUpperCase();

  if (allowedRoles && !allowedRoles.includes(role)) {
    memoryStorage.removeItem("user");
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
 